$(document).ready(function () {
    var ajaxLockActive = false;

    var controlListTableId = 'licenses_control_list_table';
    var workListTableId = 'licenses_worklist_table';
    var changePriceModalId = 'change_price_on_license_or_worklist_modal';
    var changeCommentModalId = 'change_module_comment_modal';
    var blockCompanyModalId = 'block_company_modal';
    var deactivateModuleOrLicenseButtonId = 'deactivate_license_or_module';
    var reactivateModuleOrLicenseButtonId = 'reactivate_license_or_module';

    var ajaxPathLicense = '/action/licenses';
    var ajaxPathLicenseDetails = '/action/licenses/getDetails';
    var ajaxPathCompanyModule = '/action/companyModule/';
    let ajaxPathLicenseForm = '/action/license-form';
    var ajaxPathLicenseTopAccountSummary = '/action/licenses/top-account-summary';
    var ajaxPathLicenseTotalSummary = '/action/licenses/total-summary';
    var ajaxPathLicenseControlList = '/action/licenses/control-list';
    var ajaxPathLicenseProcessedLog = '/action/licenses/processed-log';
    var ajaxPathLicenseChangeLog = '/action/licenses/change-log';
    let ajaxPathLicenseReport = '/action/licenses/report';
    let reportListWrapper = $('div#report_list_wrapper');
    let licenseListWrapper = $('div#license_list_wrapper');
    var totalSummaryListWrapper = $('div#total_summary_account_list_wrapper');
    let dealerDropdownWrapper = $('div#dealer_dropdown_wrapper');
    var controlListTable = $('table#' + controlListTableId);
    var totalSummarySingleAccountWrapper = $('div#total_summary_single_account_wrapper');
    var controlProcessedLogTable = $('table#licenses_processed_log_table');
    let reportTable = $('table#license_report_table');
    let controlListLoaded = false;

    let tailwindChangePriceModal = null;
    let tailwindChangeCommentModal = null;
    let tailwindBlockAccountModal = null;
    let worklistControlChart = null;
    let $activeDrawerRow = null;

    function initializeCommentPopovers() {
        if (typeof tippy !== 'undefined') {
            document.querySelectorAll('[data-tooltip]').forEach(function(el) {
                if (el._tippy) {
                    el._tippy.destroy();
                }
            });

            tippy('[data-tooltip]', {
                content(reference) {
                    const tooltipSelector = reference.getAttribute('data-tooltip');
                    const tooltipElement = document.querySelector(tooltipSelector);
                    return tooltipElement ? tooltipElement.innerHTML : '';
                },
                allowHTML: true,
                interactive: true,
                placement: 'top',
                arrow: true,
                theme: 'light',
                maxWidth: 'none',
                width: 'auto',
                trigger: 'mouseenter',
                onMount(instance) {
                    const box = instance.popper.querySelector('.tippy-box');
                    if (box) {
                        box.style.maxWidth = 'none';
                        box.style.width = '22rem';
                    }
                }
            });
        }
    }

    function fetchExpirationDateChangeForDetailRow($row) {
        const licenseKey = $row.attr('license');
        if (!licenseKey) {
            return;
        }

        const $detailRow = $row.next('tr.license-detail-row');
        if (!$detailRow.length) {
            return;
        }

        const $placeholder = $detailRow.find('.license-expiration-change-placeholder');
        const $changeHeader = $detailRow.find('.license-expiration-change-header');
        const $changeCell = $detailRow.find('.license-expiration-change-cell');
        if (!$placeholder.length || $placeholder.data('expiration-change-loaded')) {
            return;
        }
        $placeholder.data('expiration-change-loaded', true);

        $.ajax({
            type: 'GET',
            url: ajaxPathLicenseChangeLog + '/' + encodeURIComponent(licenseKey),
            dataType: 'json'
        }).done(function (data) {
            if (!data || data.expiration_date_changed !== true) {
                $placeholder.text('');
                $changeHeader.addClass('hidden');
                $changeCell.addClass('hidden');
                return;
            }
            const oldDateText = data.former_expiration_date && data.former_expiration_date !== '' ? data.former_expiration_date : 'Ukjent';
            $placeholder.text('Tidligere: ' + oldDateText);
            $changeHeader.removeClass('hidden');
            $changeCell.removeClass('hidden');
        }).fail(function () {
            $placeholder.text('');
            $changeHeader.addClass('hidden');
            $changeCell.addClass('hidden');
        });
    }

    setTimeout(function() {
        initializeCommentPopovers();
    }, 100);

    function updateWorklistControlChart() {
        if (typeof Chart === 'undefined') {
            return;
        }

        const ctx = document.getElementById('licenses_worklist_control_chart');
        if (!ctx) {
            return;
        }

        const worklistCount = $('#licenses_worklist_table tbody tr', document).length;
        const controlCount = $('#licenses_control_list_table tbody tr', document).length;

        const data = [worklistCount, controlCount];

        const config = {
            type: 'doughnut',
            data: {
                labels: ['Arbeidsliste', 'Kontrolliste'],
                datasets: [{
                    data: data,
                    backgroundColor: ['#0ea5e9', '#f97316'],
                    borderWidth: 0
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    }
                },
                cutout: '55%'
            }
        };

        if (worklistControlChart) {
            worklistControlChart.data.datasets[0].data = data;
            worklistControlChart.update();
        } else {
            worklistControlChart = new Chart(ctx, config);
        }
    }

    function toggleLicenseDetails(iconElement) {
        const $icon = $(iconElement);
        const $row = $icon.closest('tr');
        let $detailRow = $row.next('tr.license-detail-row');

        if ($detailRow.length) {
            if ($detailRow.hasClass('hidden')) {
                $detailRow.removeClass('hidden');
                $icon.addClass('rotated');
            } else {
                $detailRow.addClass('hidden');
                $icon.removeClass('rotated');
            }
            return;
        }

        if ($row.data('details-loading')) {
            return;
        }

        $row.data('details-loading', true);
        $icon.addClass('rotated');

        const colSpan = $row.children('td').length || 8;
        $detailRow = $(
            '<tr class="license-detail-row">' +
            '<td colspan="' + colSpan + '" class="px-5 py-3 border-b">' +
            '<div class="p-2 text-sm text-slate-500">Laster detaljer...</div>' +
            '</td>' +
            '</tr>'
        );

        $row.after($detailRow);

        $.ajax({
            type: 'GET',
            url: ajaxPathLicenseDetails,
            data: {
                sync_code: $icon.data('sync-code') || '',
                company_module_id: $icon.data('company-module-id') || '',
                license: $icon.data('license') || ''
            },
            dataType: 'json'
        }).success(function (data) {
            if (data && data.html) {
                $detailRow.replaceWith(data.html);
                initializeCommentPopovers();
                fetchExpirationDateChangeForDetailRow($row);
            } else {
                $detailRow.find('td').html('<div class="p-2 text-sm text-danger">Kunne ikke laste detaljer.</div>');
                $icon.removeClass('rotated');
            }
        }).error(function () {
            $detailRow.find('td').html('<div class="p-2 text-sm text-danger">Kunne ikke laste detaljer.</div>');
            $icon.removeClass('rotated');
        }).always(function () {
            $row.data('details-loading', false);
        });
    }

    function clearDrawerRowHighlight() {
        if ($activeDrawerRow && $activeDrawerRow.length) {
            $activeDrawerRow.removeClass('license-drawer-active');
        }
        $activeDrawerRow = null;
    }

    function setDrawerRowHighlight($row) {
        if (!$row || !$row.length) {
            clearDrawerRowHighlight();
            return;
        }

        if ($row.hasClass('license-detail-row')) {
            const $prev = $row.prev('tr');
            if ($prev.length) {
                $row = $prev;
            }
        }

        if ($activeDrawerRow && $activeDrawerRow[0] === $row[0]) {
            return;
        }

        clearDrawerRowHighlight();
        $activeDrawerRow = $row;
        $activeDrawerRow.addClass('license-drawer-active');
    }

    function setDrawerPush(open) {
        const isDesktop = window.matchMedia('(min-width: 768px)').matches;
        const $wrap = $('#licenses_page_wrapper');
        const $drawer = $('#license_list_from_worklist');

        if (!isDesktop) {
            $wrap.css('padding-right', '');
            return;
        }

        const w = $drawer.outerWidth() || 360;
        const pad = open ? `${w}px` : '';
        $wrap.css('padding-right', pad);
    }

    function openWorklistDrawer() {
        const $drawerContainer = $('#license_worklist_drawer');
        const $drawer = $('#license_list_from_worklist');

        if ($drawer.hasClass('translate-x-0')) {
            return;
        }
        $drawerContainer.removeClass('hidden');

        requestAnimationFrame(() => {
            $drawer.removeClass('translate-x-full opacity-0 pointer-events-none')
                .addClass('translate-x-0 opacity-100 pointer-events-auto');
        });
        setDrawerPush(true);
    }

    function closeWorklistDrawer() {
        const $drawerContainer = $('#license_worklist_drawer');

        $('#license_list_from_worklist')
            .addClass('translate-x-full opacity-0 pointer-events-none')
            .removeClass('translate-x-0 opacity-100 pointer-events-auto');

        setDrawerPush(false);
        clearDrawerRowHighlight();

        setTimeout(() => $drawerContainer.addClass('hidden'), 500);
    }


    $(window).on('resize', () => setDrawerPush($('#license_list_from_worklist').hasClass('translate-x-0')));



    $(document).on('click', '.license-detail-icon', function(e) {
        e.stopPropagation();
        toggleLicenseDetails(this);
        return false;
    });

    $(document).on('click', '#license_worklist_drawer_close', function (e) {
        e.stopPropagation();
        closeWorklistDrawer();
        return false;
    });

    // Datepicker from
    $("form#license-work-list-date-form input#from-license").datepicker({
        closeText: 'Lukk',
        prevText: '&laquo;Forrige',
        nextText: 'Neste&raquo;',
        currentText: 'I dag',
        monthNames: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
        dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
        dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
        dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
        weekHeader: 'Uke',
        dateFormat: 'dd.mm.yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',
        changeMonth: true,
        changeYear: true,
        onClose: function (selectedDate) {
            $("form#license-work-list-date-form input#to-license").datepicker("option", "minDate", selectedDate);
        }
    });

    // Datepicker to
    $("form#license-work-list-date-form input#to-license").datepicker({
        closeText: 'Lukk',
        prevText: '&laquo;Forrige',
        nextText: 'Neste&raquo;',
        currentText: 'I dag',
        monthNames: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
        dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
        dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
        dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
        weekHeader: 'Uke',
        dateFormat: 'dd.mm.yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',
        changeMonth: true,
        changeYear: true,
        onClose: function (selectedDate) {
            $("form#license-work-list-date-form input#to-license").datepicker("option", "minDate", selectedDate);
        }
    });

    // Edit‑ikon i arbeidslista → åpne license_form i drawer
    $(document).on('click', "table#licenses_worklist_table td.edit_license_button_td div.btn", function () {
        if (ajaxLockActive) return false;

        ajaxLockActive = true;
        showTailwindPreloader();
        $('#license_worklist_drawer_content', document).html('');
        openWorklistDrawer();
        clearDrawerRowHighlight();

        var tr = $(this).closest('tr');
        setDrawerRowHighlight(tr);
        var licenseKey = tr.attr('license');
        var syncCode = tr.attr('sync_code');
        console.log('Klikk på edit_license_button_td, license:', licenseKey, 'sync:', syncCode);

        $.ajax({
            type: 'GET',
            url: ajaxPathLicenseForm + '/' + licenseKey,
            data: { sync_code: syncCode },
            dataType: 'json'
        }).success(function (data) {
            $('#license_worklist_drawer_content', document).html(data.html);
            activateLicenseDatePickers();
            initializeCommentPopovers();
        }).error(function () {
            alert('Kunne ikke hente skjema');
        }).always(function () {
            ajaxLockActive = false;
            hideTailwindPreloader();
        });
        return false;
    });

    $(document).on('click', '#license_worklist_drawer_close', function (e) {
        e.stopPropagation();
        closeWorklistDrawer();
        return false;
    });

    // Edit license information (license_form inside license drawer)
    $(document).on('click', "div#license_worklist_drawer form[name='license_form'] div#save_license", function () {
        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }
        const $form = $(this).closest('form[name=\"license_form\"]');
        let licenseKey = $form.find('input[name=\"license_key\"]').val();

        ajaxLockActive = true;
        showTailwindPreloader();
        // Post serialized form and save JointAccountsGroup
        $.ajax({
            type: 'PUT',
            url: ajaxPathLicense + '/' + licenseKey,
            data: {
                params_serialized: $form.serialize()
            },
            dataType: 'json'
        }).success(function () {
            reloadWorkList();
        }).error(function (data) {
            alert('Kunne ikke lagre!');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    $(document).on('click', "div#license_worklist_drawer form[name='license_form'] div#deactivate_license", function () {
        if (!confirm('Er du sikker på at du vil deaktivere lisens? Ikke deaktiver ved manglende betaling, da skal konto blokkeres fra forhandlerconfig')) {
            return;
        }

        const $form = $(this).closest('form[name=\"license_form\"]');
        changeLicenseStatus($form.find('input[name=\"license_key\"]').val(), 0, reloadWorkList);
    });

    $(document).on('click', "div#license_worklist_drawer form[name='license_form'] div#activate_license", function () {
        if (!confirm('Er du sikker på at du vil aktivere lisens?')) {
            return;
        }

        const $form = $(this).closest('form[name=\"license_form\"]');
        changeLicenseStatus($form.find('input[name=\"license_key\"]').val(), 1, reloadWorkList);
    });

    $(document).on('click', "div#license_worklist_drawer form[name='license_form'] div#detach_license", function () {
        if (ajaxLockActive) {
            return false;
        }
        if (!confirm('Er du sikker på at du vil frigjøre lisens?')) {
            return;
        }
        ajaxLockActive = true;
        const $form = $(this).closest('form[name="license_form"]');
        let licenseKey = $form.find('input[name="license_key"]').val();

        //Post serialized form and save JointAccountsGroup
        $.ajax({
            type: 'PUT',
            url: ajaxPathLicense + '/' + licenseKey + '/detach',
            dataType: 'json'
        }).success(function () {
            $('div#license_action_wrapper').html('<div class="alert alert-success">Lagret</div>');
            reloadWorkList();
        }).error(function (data) {
            alert('Kunne ikke frigjøre lisens!');
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    });

    // Mark license as processed
    $(document).on('click', "table#licenses_worklist_table td.processed_button_td div.btn, table#licenses_control_list_table td.processed_button_td div.btn", function () {
        var tr = $(this).closest('tr');

        // Finn prisinput på raden eller i detaljraden under
        var priceInput = $('input.module_price', tr);
        if (!priceInput.length) {
            var detailRow = tr.next('tr.license-detail-row');
            if (detailRow.length) {
                priceInput = $('input.module_price', detailRow);
            }
        }

        // if (!priceInput.length) {
        //     alert('Fant ingen prisfelt på raden. Åpne detaljene og prøv igjen.');
        //     return;
        // }

        var priceExVat = (priceInput.val() || '').toString().replace(',', '.');

        // if (priceExVat === '' || isNaN(priceExVat)) {
        //     alert('Ugyldig pris: ' + priceExVat);
        //     return;
        // }

        if (tr.hasClass('license')) {
            var license = tr.attr('license');
            markLicenseAsProcessed(tr, license, priceExVat);
        } else {
            // Module
            var companyModuleId = tr.attr('company_module_id');
            var syncCode = tr.attr('sync_code');
            markModuleAsProcessed(tr, companyModuleId, priceExVat, syncCode);
        }
    });

    // Mark license as unprocessed
    $(document).on('click', "table#licenses_processed_log_table td.unprocess_button_td div.btn", function () {
        var tr = $(this).closest('tr');

        if (tr.hasClass('license')) {
            var license = tr.attr('license');
            markLicenseAsUnproccesed(tr, license);
        } else {
            // Module
            var companyModuleId = tr.attr('company_module_id');
            var syncCode = tr.attr('sync_code');
            markModuleAsUnproccesed(tr, companyModuleId, syncCode);
        }
    });

    // Mark as needs to be controlled
    $('table#licenses_worklist_table td.control_button_td div.btn').click(function () {
        var tr = $(this).closest('tr');

        if (tr.hasClass('license')) {
            var license = tr.attr('license');
            markLicenseAsControl(tr, license);
        } else {
            // Module
            var companyModuleId = tr.attr('company_module_id');
            var syncCode = tr.attr('sync_code');
            markModuleAsControl(tr, companyModuleId, syncCode);
        }

    });

    // click on account in total summary
    $(document).on('click', "div#total_summary_account_list_wrapper table tr td", function () {
        var tr = $(this).closest('tr');
        var topLevelSyncCode = tr.attr('top_level_sync_code');

        showTailwindPreloader();

        displayAccountLicenseListInTotalSummary(topLevelSyncCode)
    });

    // Klikk på rad i arbeidslista → last detaljliste i drawer
    $(document).on(
        'click',
        "table#licenses_worklist_table td:not(.processed_button_td, .control_button_td, .edit_license_button_td, .unprocess_button_td, .price_td, .comment_can_be_edited)",
        function () {
            var tr = $(this).closest('tr');
            var syncCode = tr.attr('sync_code');
            var topLevelSyncCode = tr.attr('top_level_sync_code');

            setDrawerRowHighlight(tr);
            displayAccountLicenseList(syncCode, topLevelSyncCode, '#license_worklist_drawer_content');
        }
    );

    $(document).on('click', "table#licenses_control_list_table td:not(.processed_button_td, .control_button_td, .edit_license_button_td, .unprocess_button_td, .price_td, .comment_can_be_edited)", function () {
        var tr = $(this).closest('tr');
        var syncCode = tr.attr('sync_code');
        var topLevelSyncCode = tr.attr('top_level_sync_code');

        if (!syncCode) {
            return;
        }

        // Bruk samme drawer som worklist
        setDrawerRowHighlight(tr);
        displayAccountLicenseList(syncCode, topLevelSyncCode, '#license_worklist_drawer_content');
    });

    // Klikk på rad i processed log → last detaljliste i drawer
    // Unntak: ikke trigge når vi klikker på kommentar‑cellen
    $(document).on('click', "table#licenses_processed_log_table tbody tr td:not(.processed_button_td, .control_button_td, .edit_license_button_td, .unprocess_button_td, .price_td, .comment_can_be_edited)", function () {
        var tr = $(this).closest('tr');
        var syncCode = tr.attr('sync_code');
        var topLevelSyncCode = tr.attr('top_level_sync_code');

        if (!syncCode) {
            return;
        }

        setDrawerRowHighlight(tr);
        displayAccountLicenseList(syncCode, topLevelSyncCode, '#license_worklist_drawer_content');
    });

    $('#total_summary_link-tab').click(function () {
        if ($('div#total-summary-loading-div', totalSummaryListWrapper).length) {
            console.log('returnerer her ja');
            return;
        }
        totalSummaryListWrapper.html('');
        totalSummarySingleAccountWrapper.html('');
        removeAccountSummaryAndLicenses();

        showTailwindPreloader();

        getTotalSummary();
    });

    $('#licenses-control-list-link-tab').click(function () {
        $('#licenses_control_list_wrapper', document).addClass('hidden');
        $('table#licenses_control_list_table tbody', document).html('');
        $('#license_list_from_control_list', document).html('');
        removeAccountSummaryAndLicenses();

        showTailwindPreloader();

        getControlList(false);
    });

    $('#licenses-processed-log-link-tab').click(function () {
        $('#licenses_processed_log_wrapper', document).addClass('hidden');
        $('table#licenses_processed_log_table tbody', document).html('');
        removeAccountSummaryAndLicenses();

        showTailwindPreloader();

        getProcessedLogList();
    });

    $(document).on('click', "#licenses-worklist-tab", function () {
        removeAccountSummaryAndLicenses();

        return false;
    })

    // click on a license or module in license list, inside work list funciton
    $(document).on('click', "#existing_licenses_wrapper .module, #licenses-worklist div#license_list_from_worklist .license, #licenses-worklist div#license_list_from_worklist .module", function () {
        const price = $.trim($('.price', $(this)).html());
        let companyModuleId = 0;
        let license = '';
        if ($(this).hasClass('module')) {
            companyModuleId = $(this).attr('company_module_id');
        } else if ($(this).hasClass('license')) {
            license = $(this).attr('license');
        }

        let parentSelector = '';
        if ($(this).closest('#licenses_page_wrapper').length) {
            parentSelector = '#licenses_page_wrapper';
        } else if ($(this).closest('#customer_licenses_wrapper').length) {
            parentSelector = '#customer_licenses_wrapper';
        }

        initModalChangePrice(companyModuleId, license, price, parentSelector);
    });

    $(document).on('click', "table#" + controlListTableId + " tr td.comment_can_be_edited [data-tooltip], table#" + workListTableId + " tr td.comment_can_be_edited [data-tooltip], table#" + controlListTableId + " tr td.comment_can_be_edited .lucide-help-circle, table#" + workListTableId + " tr td.comment_can_be_edited .lucide-help-circle", function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
    });

    $(document).on('click', "table#" + workListTableId + " tr td.expiration_date_td [data-tooltip], table#" + workListTableId + " tr td.expiration_date_td .expiration-change-indicator", function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
    });

    

    $(document).on('click', "table#" + controlListTableId + " tr td.comment_can_be_edited, table#" + workListTableId + " tr td.comment_can_be_edited", function (e) {
        if ($(e.target).closest('.lucide-help-circle, [data-tooltip]').length) {
            return false;
        }
        
        let tr = $(this).closest('tr');
        let companyModuleId = 0;
        let license = '';
        let comment = $.trim($('span.comment', $(this)).html());
        if (tr.hasClass('module')) {
            companyModuleId = tr.attr('company_module_id');
        } else if (tr.hasClass('license')) {
            license = tr.attr('license');
        }

        if (isNaN(companyModuleId)) {
            return;
        }

        initModalChangeComment(companyModuleId, license, comment);
    });

    // click on a license or module in license list, inside total summary view
    $(document).on('click', "#total_summary_single_account_wrapper .licenses_table_wrapper tr", function () {
        var companyModuleId = 0;
        var license = '';
        var price = $.trim($('.price', $(this)).html());
        var includeDeactivateOption = false;
        var includeReactivateOption = false;
        if ($(this).hasClass('module')) {
            companyModuleId = $(this).attr('company_module_id');

            if ($(this).hasClass('list-group-item-danger')) {
                // This module is deactivated
                // Updating price will automatically reactivate this module, reactivate module before updating price
                return;
            }
        } else if ($(this).hasClass('license')) {
            license = $(this).attr('license');
            includeDeactivateOption = true;

            if ($(this).hasClass('list-group-item-danger')) {
                includeReactivateOption = true;
                includeDeactivateOption = false;
            }
        }
        initModalChangePrice(companyModuleId, license, price, '#licenses_page_wrapper', includeDeactivateOption, includeReactivateOption);

        return false;
    });

    // Change module price
    $(document).on('click', "#change_module_or_license_price_modal #save_new_price_company_module", function () {
        const priceExVat = $('#change_module_or_license_price_modal input[name="price_ex_vat"]', document).val();
        const companyModuleId = $(this).attr('company_module_id');

        showTailwindPreloader();

        $.ajax({
            type: 'POST',
            url: ajaxPathCompanyModule,
            data: {
                company_module_id: companyModuleId,
                price_ex_vat_for_customer: priceExVat
            }
        }).success(function (data) {
            tailwindChangePriceModal.hide();
            $('[company_module_id="' + companyModuleId + '"] .price').html(priceExVat);
        }).error(function (data) {
            alert('Kunne ikke lagre pris.');
            tailwindChangePriceModal.hide();
        }).always(function () {
            hideTailwindPreloader();
        });
        return false;
    });

    $(document).on('click', "#change_module_or_license_price_modal #save_new_price_license", function () {
        const priceExVat = $('#change_module_or_license_price_modal input[name="price_ex_vat"]', document).val();
        const license = $(this).attr('license');

        showTailwindPreloader();

        $.ajax({
            type: 'PUT',
            url: ajaxPathLicense + '/' + license,
            data: {
                price_ex_vat: priceExVat
            },
            dataType: 'json'
        }).success(function () {
            tailwindChangePriceModal.hide();
            $('[license="' + license + '"] .price').html(priceExVat);
        }).error(function (data) {
            alert('Kunne ikke lagre pris.');
            tailwindChangePriceModal.hide();
        }).always(function () {
            hideTailwindPreloader();
        });
        return false;
    });

    // Change module comment
    $(document).on('click', "#change_module_or_license_comment_modal #save_new_module_comment", function () {
        let comment = $('#change_module_or_license_comment_modal textarea[name="new_comment"]', document).val();
        saveModuleComment($(this).attr('company_module_id'), comment);
    });

    // Change license comment
    $(document).on('click', "#change_module_or_license_comment_modal #save_new_module_license", function () {
        let comment = $('#change_module_or_license_comment_modal textarea[name="new_comment"]', document).val();
        saveLicenseComment($(this).attr('license'), comment);
    });

    // Change module price
    $(document).on('click', "#change_module_or_license_price_modal #deactivate_license_or_module", function () {
        if ($(this).attr('company_module_id') != '' && $(this).attr('company_module_id') != '0') {
            // deactivate company module id
            //deactivateModule($(this).attr('company_module_id'));
        } else {
            // deactivate license
            changeLicenseStatus($(this).attr('license'), 0, false);
            tailwindChangePriceModal.hide();
            alert('Lisens deaktivert');
        }
    });

    // Change license price
    $(document).on('click', "div#change_module_or_license_price_modal #reactivate_license_or_module", function () {
        if ($(this).attr('company_module_id') != '' && $(this).attr('company_module_id') != '0') {
            // deactivate company module id
            //deactivateModule($(this).attr('company_module_id'));
        } else {
            // deactivate license
            changeLicenseStatus($(this).attr('license'), 1, false);
            tailwindChangePriceModal.hide();
            alert('Lisens aktivert');
        }
    });

    $(document).on('click', '#customer_info_tab_content #block_accounts_and_registers, #total_summary_single_account_wrapper div#block_accounts_and_registers', function () {
        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        var companyId = $(this).attr('company_id');
        var button = $(this);

        if (!confirm('Er du sikker på at du vil blokkere bruk av denne kontoen?')) {
            return;
        }

        if (!confirm('Helt sikker?')) {
            return;
        }

        let parentSelector = '';
        if ($(this).closest('#licenses_page_wrapper').length) {
            parentSelector = '#licenses_page_wrapper';
        } else if ($(this).closest('#customer_info_tab_content').length) {
            parentSelector = '#customer_info_tab_content';
        }
        initModalBlockAccount(companyId, $(this).attr('id'), parentSelector);
        //blockCompany(companyId, button);
        return false;
    });

    // Accept blocking account
    $(document).on('click', 'div#' + blockCompanyModalId + ' button#save_company_blocked', function () {
        // Check that a save operation is not already in process
        blockCompany($(this).attr('company_id'), 'block_accounts_and_registers', $('div#' + blockCompanyModalId + ' input[name="block_account_date"]').val());
        tailwindBlockAccountModal.hide();
        return false;
    });

    $(document).on('click', '#customer_info_tab_content div#unblock_accounts_and_registers, #total_summary_single_account_wrapper div#unblock_accounts_and_registers', function () {
        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        var button = $(this);
        var companyId = $(this).attr('company_id');

        if (!confirm('Er du sikker på at du vil åpne bruk av denne kontoen?')) {
            return;
        }

        unblockCompany(companyId, button);
        return false;
    });

    $(document).on('click', '.licenses_table_wrapper .copy-license-key', function () {
        let licenseKey = $(this).closest('.license').attr('license_key_with_dashes');
        let listElement = $(this).closest('.license-item.license');
        copyToClipboard(licenseKey, listElement, 'top');

        return false;
    });

    $(document).on('click', 'form#license_form .copy-license-key-inside-form', function () {
        let licenseKey = $(this).attr('license_key_with_dashes');
        let legend = $('#license_title_wrap', document);
        copyToClipboard(licenseKey, legend, 'left');

        return false;
    });

    function getDeactivationConfirmMessage(moduleId) {
        const messages = {
            5: 'Er du sikker på at du vil deaktivere F-Order?\n\nDette vil slette F-order med alle satte konfigurasjoner\n\nog e-post blir sendt til systemutvikling for å ta ned nettsiden',
            21: 'Er du sikker på at du vil deaktivere Digital Signage?\n\nDigital signage vil bli slettet og e-post blir sendt til systemutvikling for å ta ned nettsiden',
            15: 'Er du sikker på at du vil deaktivere supportavtalen?',
            12: 'Er du sikker på at du vil deaktivere API modulen?\n\n Dette vil fjerne tilgang til API for kunden',
            10: 'Er du sikker på at du vil deaktivere regnskapsintegrasjon?\n\n Dette vil fjerne konfigruasjonen av regnskapsintegrasjonen.'
        };

        return messages[moduleId] || 'Er du sikker på at du vil deaktivere denne modulen? Dette vil også deaktivere tilhørende konfigurasjoner.';
    }

    // Deactivate module button
    $(document).on('click', 'button.deactivate-module-button', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (ajaxLockActive) {
            return false;
        }

        let companyModuleId = $(this).data('company-module-id');
        let moduleId = $(this).data('module-id');
        let button = $(this);

        // Find syncCode from the h3 element above the licenses table wrapper
        const wrapper = button.closest('.licenses_table_wrapper');
        let syncCode = '';
        if (wrapper.length) {
            syncCode = wrapper.prev('h3').data('sync-code');
        }

        // Fallbacks if not found
        if (!syncCode) {
            syncCode = $('#customer_data_container').attr('data-sync-code')
                || $('#customer_info_tab input#sync_code').val()
                || '';
        }

        console.log('syncCode used for churn (module):', syncCode);

        let confirmMessage = getDeactivationConfirmMessage(parseInt(moduleId, 10));
        if (!confirm(confirmMessage)) {
            return false;
        }

        if (typeof window.openModuleChurnModal === 'function') {
            window.openModuleChurnModal(moduleId, syncCode, function () {
                deactivateModule(companyModuleId, moduleId, button, syncCode);
            });
        } else {
            deactivateModule(companyModuleId, moduleId, button, syncCode);
        }

        return false;
    });

    function deactivateModule(companyModuleId, moduleId, button, syncCode) {
        ajaxLockActive = true;
        button.prop('disabled', true);

        $.ajax({
            type: 'POST',
            url: ajaxPathCompanyModule + 'deactivate',
            data: {
                company_module_id: companyModuleId,
                module_id: moduleId
            },
            dataType: 'json'
        }).done(function (data) {
            if (data && data.success) {
                if (moduleId == 15) {
                    updateSupportAgreementElement(false);
                }
                reloadLicenseListAfterModuleChange(syncCode);
                alert('Modul deaktivert');
            } else {
                alert('Kunne ikke deaktivere modul: ' + (data && data.message ? data.message : 'Ukjent feil'));
            }
        }).fail(function (xhr, status, error) {
            console.error('XHR Status:', xhr.status);
            console.error('Response Text:', xhr.responseText);
            console.error('Error:', error);
        }).always(function () {
            ajaxLockActive = false;
            button.prop('disabled', false);
        });
    }

    function updateSupportAgreementElement(isActive) {
        var $supportAgreementRow = $('#customer_info_tab table td:contains("Supportavtale:")').closest('tr');

        if ($supportAgreementRow.length) {
            var $valueCell = $supportAgreementRow.find('td').eq(1);

            if (isActive) {
                $valueCell.html('<span class="text-success"><i class="glyphicon glyphicon-ok-sign"></i> Aktivert</span>');
            } else {
                $valueCell.html('<input type="checkbox" id="support_agreement" name="support_agreement" value="1"/>');
            }
        }
    }

    function reloadLicenseListAfterModuleChange(syncCode) {
        var existingLicensesWrapper = $('div#existing_licenses_wrapper');
        var customerId = $('#customer_data_container').attr('data-customer-id');

        if (existingLicensesWrapper.length && customerId) {
            existingLicensesWrapper.html('<div class="text-center"><img src="/includes/charts/gfx/ajax-loader.gif" alt="Loading..." /></div>');
            $.ajax({
                type: 'GET',
                url: ajaxPathLicense,
                data: { customer_id: customerId },
                dataType: 'json'
        }).success(function (data) {
            existingLicensesWrapper.html(data.html);
            $('[data-toggle="tooltip"]').tooltip();
            initializeCommentPopovers();
        }).error(function () {
                alert('Kunne ikke oppdatere lisensliste');
            });
        } else if (syncCode) {
            displayAccountLicenseListInTotalSummary(syncCode);
        } else {
            location.reload();
        }
    }

    function saveModuleComment(companyModuleId, comment) {
        showTailwindPreloader();

        $.ajax({
            type: 'POST',
            url: ajaxPathCompanyModule,
            data: {
                company_module_id: companyModuleId,
                comment: comment,
                keep_existing_module_status: 1
            }
        }).success(function (data) {
            tailwindChangeCommentModal.hide();
            $('tr[company_module_id="' + companyModuleId + '"] td.comment_can_be_edited span.comment').html(comment);
        }).error(function (data) {
            alert('Kunne ikke lagre kommentar.');
            tailwindChangeCommentModal.hide();
        }).always(function () {
            hideTailwindPreloader();
        });
        return false;
    }


    function saveLicenseComment(licenseKey, comment) {
        showTailwindPreloader();

        $.ajax({
            type: 'PUT',
            url: ajaxPathLicense + '/' + licenseKey,
            data: {
                comment: comment,
                keep_processing_state_unchanged: 1
            },
        }).success(function () {
            tailwindChangeCommentModal.hide();
            $('tr[license="' + licenseKey + '"] td.comment_can_be_edited span.comment').html(comment);
        }).error(function () {
            alert('Kunne ikke lagre kommentar.');
            tailwindChangeCommentModal.hide();
        }).always(function () {
            hideTailwindPreloader();
        });
        return false;
    }

    function initModalChangeComment(companyModuleId, license, existingComment, parentSelector = '#licenses_page_wrapper') {
        $('#change_module_or_license_comment_modal', document).remove();
        tailwindChangeCommentModal = null;

        let saveButtonId = 'save_new_module_license';

        if (companyModuleId != 0) {
            saveButtonId = 'save_new_module_comment';
        }

        $(parentSelector, document).append(`<div data-tw-backdrop="" aria-hidden="true" tabindex="-1" id="change_module_or_license_comment_modal" class="modal group bg-gradient-to-b from-theme-1/50 via-theme-2/50 to-black/50 transition-[visibility,opacity] w-screen h-screen fixed left-0 top-0 [&amp;:not(.show)]:duration-[0s,0.2s] [&amp;:not(.show)]:delay-[0.2s,0s] [&amp;:not(.show)]:invisible [&amp;:not(.show)]:opacity-0 [&amp;.show]:visible [&amp;.show]:opacity-100 [&amp;.show]:duration-[0s,0.4s]">
                                            <div class="w-[90%] mx-auto bg-white relative rounded-md shadow-md transition-[margin-top,transform] duration-[0.4s,0.3s] -mt-16 group-[.show]:mt-16 group-[.modal-static]:scale-[1.05] sm:w-[460px]">
                                                <div class="flex items-center px-5 py-3 border-b border-slate-200/60">
                                                    <h2 class="mr-auto text-base font-medium">
                                                        Endre kommentar
                                                    </h2>
                                                </div>
                                                <div class="p-5">
                                                    <textarea name="new_comment"
                                                     class="disabled:bg-slate-100 disabled:cursor-not-allowed [&[readonly]]:bg-slate-100 [&[readonly]]:cursor-not-allowed transition duration-200 ease-in-out w-full text-sm border-slate-200 shadow-sm rounded-md placeholder:text-slate-400/90 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40 [&[type='file']]:border file:mr-4 file:px-4 file:py-2 file:rounded-l-md file:border-0 file:border-r-[1px] file:border-slate-100/10 file:text-sm file:font-semibold file:bg-slate-100 file:text-slate-500/70 hover:file:bg-200 group-[.form-inline]:flex-1 group-[.input-group]:rounded-none group-[.input-group]:[&:not(:first-child)]:border-l-transparent group-[.input-group]:first:rounded-l group-[.input-group]:last:rounded-r group-[.input-group]:z-10" 
                                                     rows="5">${existingComment}</textarea>                                                </div>
                                                    <button type="button" 
                                                        id="${saveButtonId}"
                                                        company_module_id="${companyModuleId}"
                                                        license="${license}"
                                                        class="transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&amp;:hover:not(:disabled)]:bg-opacity-90 [&amp;:hover:not(:disabled)]:border-opacity-90 [&amp;:not(button)]:text-center disabled:opacity-70 disabled:cursor-not-allowed bg-primary border-primary text-white w-20">
                                                        Ok
                                                    </button>
                                                </div>
                                            </div>
                                        </div>`);

        setTimeout(() => {
            const modal = document.querySelector("#change_module_or_license_comment_modal");

            if (modal) {
                modal.addEventListener("hidden.tw.modal", (e) => {
                    $(e.currentTarget).remove();
                });

                tailwindChangeCommentModal = tailwind.Modal.getOrCreateInstance(modal);
                tailwindChangeCommentModal.show();
            }
        }, 0);
    }

    function initModalChangePrice(companyModuleId, license, price, parentSelector, includeDeactivateOption, includeReactivateOption) {
        $('#change_module_or_license_price_modal', document).remove();
        tailwindChangePriceModal = null;

        let saveButtonId = 'save_new_price_license';
        let deactivateHtml = '';

        if (companyModuleId != 0) {
            saveButtonId = 'save_new_price_company_module';
        }

        if (includeDeactivateOption) {
            deactivateHtml = `<button type="button" 
                                class="btn transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 [&:not(button)]:text-center disabled:opacity-70 disabled:cursor-not-allowed bg-danger border-danger text-white" 
                                id="${deactivateModuleOrLicenseButtonId}" 
                                company_module_id="${companyModuleId}" 
                                license="${license}">
                                Deaktiver
                            </button>`;
        }
        if (includeReactivateOption) {
            deactivateHtml = `<button type="button"
                                    class="btn transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&:hover:not(:disabled)]:bg-opacity-90 [&:hover:not(:disabled)]:border-opacity-90 [&:not(button)]:text-center disabled:opacity-70 disabled:cursor-not-allowed bg-success border-success text-white"
                                     id="${reactivateModuleOrLicenseButtonId}"
                                      company_module_id="${companyModuleId}"
                                       license="${license}">
                                       Reaktiver
                              </button>`;
        }

        $(parentSelector, document).append(`<div data-tw-backdrop="" aria-hidden="true" tabindex="-1" id="change_module_or_license_price_modal" class="modal group bg-gradient-to-b from-theme-1/50 via-theme-2/50 to-black/50 transition-[visibility,opacity] w-screen h-screen fixed left-0 top-0 [&amp;:not(.show)]:duration-[0s,0.2s] [&amp;:not(.show)]:delay-[0.2s,0s] [&amp;:not(.show)]:invisible [&amp;:not(.show)]:opacity-0 [&amp;.show]:visible [&amp;.show]:opacity-100 [&amp;.show]:duration-[0s,0.4s]">
                                            <div class="w-[90%] mx-auto bg-white relative rounded-md shadow-md transition-[margin-top,transform] duration-[0.4s,0.3s] -mt-16 group-[.show]:mt-16 group-[.modal-static]:scale-[1.05] sm:w-[460px]">
                                                <div class="flex items-center px-5 py-3 border-b border-slate-200/60">
                                                    <h2 class="mr-auto text-base font-medium">
                                                        Endre
                                                    </h2>
                                                </div>
                                                <div class="p-5">
                                                    <input type="text"
                                                        name="price_ex_vat"
                                                        value="${price.replace(',', '.')}"
                                                        class="disabled:bg-slate-100 disabled:cursor-not-allowed [&amp;[readonly]]:bg-slate-100 [&amp;[readonly]]:cursor-not-allowed transition duration-200 ease-in-out w-full text-sm border-slate-200 shadow-sm rounded-md placeholder:text-slate-400/90 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40 [&amp;[type='file']]:border file:mr-4 file:py-2 file:px-4 file:rounded-l-md file:border-0 file:border-r-[1px] file:border-slate-100/10 file:text-sm file:font-semibold file:bg-slate-100 file:text-slate-500/70 hover:file:bg-200 group-[.form-inline]:flex-1 group-[.input-group]:rounded-none group-[.input-group]:[&amp;:not(:first-child)]:border-l-transparent group-[.input-group]:first:rounded-l group-[.input-group]:last:rounded-r group-[.input-group]:z-10">
                                                </div>
                                                <div class="flex justify-between gap-2 px-5 py-3 text-right border-t border-slate-200/60">
                                                    <button data-tw-dismiss="modal" type="button" class="transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&amp;:hover:not(:disabled)]:bg-opacity-90 [&amp;:hover:not(:disabled)]:border-opacity-90 [&amp;:not(button)]:text-center disabled:opacity-70 disabled:cursor-not-allowed border-secondary text-slate-500 [&amp;:hover:not(:disabled)]:bg-secondary/20 mr-1 w-20">Cancel</button>
                                                    ${deactivateHtml}
                                                    <button type="button" 
                                                        id="${saveButtonId}"
                                                        company_module_id="${companyModuleId}"
                                                        license="${license}"
                                                        class="transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&amp;:hover:not(:disabled)]:bg-opacity-90 [&amp;:hover:not(:disabled)]:border-opacity-90 [&amp;:not(button)]:text-center disabled:opacity-70 disabled:cursor-not-allowed bg-primary border-primary text-white w-20">
                                                        Ok
                                                    </button>
                                                </div>
                                            </div>
                                        </div>`);

        setTimeout(() => {
            const modal = document.querySelector("#change_module_or_license_price_modal");

            if (modal) {
                modal.addEventListener("hidden.tw.modal", (e) => {
                    $(e.currentTarget).remove();
                });

                tailwindChangePriceModal = tailwind.Modal.getOrCreateInstance(modal);
                tailwindChangePriceModal.show();
            }
        }, 0);
    }

    function initModalBlockAccount(companyId, originButtonId, parentSelector) {
        if (!parentSelector) {
            console.error('Provide the parent selector to the initModalBlockAccount function');
            return;
        }

        $(`#block_company_modal`, document).remove();
        tailwindBlockAccountModal = null;

        $(parentSelector, document).append(`<div data-tw-backdrop="" aria-hidden="true" tabindex="-1" 
                            id="block_company_modal" class="modal group bg-gradient-to-b from-theme-1/50 via-theme-2/50 to-black/50 transition-[visibility,opacity] w-screen h-screen fixed left-0 top-0 [&amp;:not(.show)]:duration-[0s,0.2s] [&amp;:not(.show)]:delay-[0.2s,0s] [&amp;:not(.show)]:invisible [&amp;:not(.show)]:opacity-0 [&amp;.show]:visible [&amp;.show]:opacity-100 [&amp;.show]:duration-[0s,0.4s]">
                                            <div class="w-[90%] mx-auto bg-white relative rounded-md shadow-md transition-[margin-top,transform] duration-[0.4s,0.3s] -mt-16 group-[.show]:mt-16 group-[.modal-static]:scale-[1.05]">
                                                <div class="flex items-center px-5 py-3 border-b border-slate-200/60">
                                                    <h2 class="mr-auto text-base font-medium">
                                                        Blokker konto
                                                    </h2>
                                                </div>
                                                <div class="p-5">
                                                    <label for="regular-form-1" class="inline-block mb-2 group-[.form-inline]:mb-2 group-[.form-inline]:sm:mb-0 group-[.form-inline]:sm:mr-5 group-[.form-inline]:sm:text-right">
                                                        Dato (la stå tom for å blokkere umiddelbart)
                                                    </label>
                                                    <input 
                                                    id="block_account_date"
                                                    name="block_account_date" 
                                                    type="text" 
                                                     class="disabled:bg-slate-100 disabled:cursor-not-allowed [&amp;[readonly]]:bg-slate-100 [&amp;[readonly]]:cursor-not-allowed transition duration-200 ease-in-out w-full text-sm border-slate-200 shadow-sm rounded-md placeholder:text-slate-400/90 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40 [&amp;[type='file']]:border file:mr-4 file:py-2 file:px-4 file:rounded-l-md file:border-0 file:border-r-[1px] file:border-slate-100/10 file:text-sm file:font-semibold file:bg-slate-100 file:text-slate-500/70 hover:file:bg-200 group-[.form-inline]:flex-1 group-[.input-group]:rounded-none group-[.input-group]:[&amp;:not(:first-child)]:border-l-transparent group-[.input-group]:first:rounded-l group-[.input-group]:last:rounded-r group-[.input-group]:z-10 text-slate-500">
                                                </div>
                                                <div class="flex justify-between gap-2 px-5 py-3 text-right border-t border-slate-200/60">
                                                    <button data-tw-dismiss="modal" type="button" class="transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&amp;:hover:not(:disabled)]:bg-opacity-90 [&amp;:hover:not(:disabled)]:border-opacity-90 [&amp;:not(button)]:text-center disabled:opacity-70 disabled:cursor-not-allowed border-secondary text-slate-500 [&amp;:hover:not(:disabled)]:bg-secondary/20 mr-1 w-20">Cancel</button>
                                                    <button type="button" 
                                                        id="save_company_blocked" 
                                                        company_id="${companyId}" 
                                                        origin_button_id="${originButtonId}"
                                                        class="transition duration-200 border shadow-sm inline-flex items-center justify-center py-2 px-3 rounded-md font-medium cursor-pointer focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus-visible:outline-none [&amp;:hover:not(:disabled)]:bg-opacity-90 [&amp;:hover:not(:disabled)]:border-opacity-90 [&amp;:not(button)]:text-center disabled:opacity-70 disabled:cursor-not-allowed bg-primary border-primary text-white w-20">
                                                        Ok
                                                    </button>
                                                </div>
                                            </div>
                                        </div>`);

        setTimeout(() => {
            const modal = document.querySelector(`#block_company_modal`);

            if (modal) {
                let picker = null;
                if ($(`#block_company_modal`).find('input#block_account_date').length) {
                    picker = new Litepicker({
                        element: $(`#block_company_modal`).find('input#block_account_date')[0],
                        singleMode: true,
                        numberOfMonths: 1,
                        numberOfColumns: 1,
                        format: 'DD/MM/YYYY',
                        autoApply: true,
                        dropdowns: {
                            minYear: 2017,
                            maxYear: new Date().getFullYear(),
                            months: true,
                            years: true,
                        },
                    });

                    const today = new Date();
                    // picker.setDate(today);
                }

                modal.addEventListener("hidden.tw.modal", (e) => {
                    $(e.currentTarget).remove();
                    tailwindBlockAccountModal = null;
                    if (picker) {
                        picker.destroy();
                    }
                });

                tailwindBlockAccountModal = tailwind.Modal.getOrCreateInstance(modal);
                tailwindBlockAccountModal.show();
            }
        }, 0);
    }

    function renderTotalSummaryKpis(sums) {
        const [active, activeFlow, unused, deactivated, modules] = sums;
        const activeTotal = active + activeFlow;
        const $kpi = $('#total_summary_kpi_wrapper', document);
        if (!$kpi.length) return;

        $kpi.html(`
        <div class="rounded-2xl border border-slate-200 bg-white shadow-sm p-4 flex flex-col gap-2">
            <div class="flex flex-row items-center justify-between">
                <span class="text-xs font-medium text-slate-500">Aktive lisenser</span>
                <span class="inline-flex items-center justify-center w-7 h-7 rounded-full bg-emerald-100 text-emerald-600">
                    <i data-lucide="check-circle-2" class="w-4 h-4"></i>
                </span>
            </div>
            <div class="text-3xl font-semibold leading-tight">${activeTotal}</div>
            <span class="text-[11px] text-slate-400 uppercase tracking-wide">Totalt</span>
        </div>

        <div class="rounded-2xl border border-slate-200 bg-white shadow-sm p-4 flex flex-col gap-2">
            <div class="flex items-center justify-between">
                <span class="text-xs font-medium text-slate-500">Ubrukte lisenser</span>
                <span class="inline-flex items-center justify-center w-7 h-7 rounded-full bg-amber-100 text-amber-600">
                    <i data-lucide="clock" class="w-4 h-4"></i>
                </span>
            </div>
            <div class="text-3xl font-semibold leading-tight">${unused}</div>
            <span class="text-[11px] text-slate-400 uppercase tracking-wide">Tilgjengelige</span>
        </div>

        <div class="rounded-2xl border border-slate-200 bg-white shadow-sm p-4 flex flex-col gap-2">
            <div class="flex items-center justify-between">
                <span class="text-xs font-medium text-slate-500">Deaktiverte lisenser</span>
                <span class="inline-flex items-center justify-center w-7 h-7 rounded-full bg-rose-100 text-rose-600">
                    <i data-lucide="x-circle" class="w-4 h-4"></i>
                </span>
            </div>
            <div class="text-3xl font-semibold leading-tight">${deactivated}</div>
            <span class="text-[11px] text-slate-400 uppercase tracking-wide">Historikk</span>
        </div>

        <div class="rounded-2xl border border-slate-200 bg-white shadow-sm p-4 flex flex-col gap-2">
            <div class="flex items-center justify-between">
                <span class="text-xs font-medium text-slate-500">Aktive moduler</span>
                <span class="inline-flex items-center justify-center w-7 h-7 rounded-full bg-sky-100 text-sky-600">
                    <i data-lucide="puzzle" class="w-4 h-4"></i>
                </span>
            </div>
            <div class="text-3xl font-semibold leading-tight">${modules}</div>
            <span class="text-[11px] text-slate-400 uppercase tracking-wide">Totalt</span>
        </div>
    `);

        if (window.lucide) {
            lucide.createIcons();
        }
    }


    function renderTotalSummaryChart(sums) {
        console.log('renderTotalSummaryChart', sums);
        if (typeof Chart === 'undefined') return;

        const [active, , unused, deactivated] = sums;
        const ctx = document.getElementById('licenses_total_summary_chart');
        if (!ctx) return;

        const data = {
            labels: ['Aktive', 'Ubrukte', 'Deaktiverte'],
            datasets: [{
                data: [active, unused, deactivated],
                backgroundColor: ['#22c55e', '#eab308', '#ef4444'],
                borderWidth: 0
            }]
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: 'bottom' } },
            cutout: '65%'
        };

        if (totalSummaryChart) {
            totalSummaryChart.data = data;
            totalSummaryChart.update();
        } else {
            totalSummaryChart = new Chart(ctx, {
                type: 'doughnut',
                data: data,
                options: options
            });
        }
    }

    function injectTotalSummarySearch() {
        const $wrapper = $('#total_summary_account_list_wrapper', document);
        const $table = $('#total_summary_account_table', $wrapper);
        if (!$table.length) return;
        if ($('#total_summary_search', $wrapper).length) return;

        $wrapper.prepend(`
        <div class="px-5 pt-5">
            <div class="relative max-w-xs">
                <input id="total_summary_search"
                       type="text"
                       placeholder="Søk på konto/firma…"
                       class="w-full border rounded-md py-2 pl-9 pr-3 text-sm
                              border-slate-200
                              focus:ring-4 focus:ring-primary/20 focus:border-primary" />
                <i data-lucide="search"
                   class="w-4 h-4 absolute left-2.5 top-2.5 text-slate-400"></i>
            </div>
        </div>
    `);

        if (window.lucide) {
            lucide.createIcons();
        }

        const $rows = $table.find('tbody tr').not(':first');

        $('#total_summary_search', $wrapper).on('input', function () {
            const q = $(this).val().toString().toLowerCase();

            $rows.each(function () {
                const nameCell = $(this).children('td').eq(0);
                const text = nameCell.text().toLowerCase();
                $(this).toggle(!q || text.indexOf(q) !== -1);
            });
        });
    }

    function initializeTotalSummarySorting() {
        const $table = $('#total_summary_account_table', document);
        if (!$table.length) {
            return;
        }

        const $headers = $table.find('thead th');
        const sortConfig = [
            { index: 0, type: 'text' },
            { index: 1, type: 'number' },
            { index: 2, type: 'number' },
            { index: 3, type: 'number' },
            { index: 4, type: 'number' },
            { index: 5, type: 'number' }
        ];

        $headers.each(function (headerIndex) {
            const config = sortConfig[headerIndex];
            if (!config) {
                return;
            }

            const $header = $(this);
            $header
                .attr('data-sort-index', config.index)
                .attr('data-sort-type', config.type)
                .attr('data-sort-direction', headerIndex === 0 ? 'asc' : '')
                .attr('title', 'Klikk for å sortere')
                .addClass('cursor-pointer select-none');

            if (!$header.find('.total-summary-sort-indicator').length) {
                $header.append(' <span class="total-summary-sort-indicator text-xs opacity-70">' + (headerIndex === 0 ? '^' : '') + '</span>');
            }
        });

        $(document)
            .off('click.totalSummarySort', '#total_summary_account_table thead th')
            .on('click.totalSummarySort', '#total_summary_account_table thead th', function () {
                const $header = $(this);
                const sortIndex = Number($header.attr('data-sort-index'));
                const sortType = $header.attr('data-sort-type') || 'text';
                const currentDirection = $header.attr('data-sort-direction') === 'asc' ? 'asc' : 'desc';
                const nextDirection = currentDirection === 'asc' ? 'desc' : 'asc';
                const $tbody = $table.find('tbody');
                const $rows = $tbody.find('tr').not(':first').get();

                $table.find('thead th').attr('data-sort-direction', '');
                $table.find('.total-summary-sort-indicator').text('');
                $header.attr('data-sort-direction', nextDirection);
                $header.find('.total-summary-sort-indicator').text(nextDirection === 'asc' ? '^' : 'v');

                $rows.sort(function (rowA, rowB) {
                    const $rowA = $(rowA).children('td').eq(sortIndex);
                    const $rowB = $(rowB).children('td').eq(sortIndex);
                    let valueA = $rowA.text().trim();
                    let valueB = $rowB.text().trim();

                    if (sortType === 'number') {
                        valueA = valueA === '-' ? 0 : parseInt(valueA, 10) || 0;
                        valueB = valueB === '-' ? 0 : parseInt(valueB, 10) || 0;
                    } else {
                        valueA = valueA.toLowerCase();
                        valueB = valueB.toLowerCase();
                    }

                    if (valueA < valueB) {
                        return nextDirection === 'asc' ? -1 : 1;
                    }
                    if (valueA > valueB) {
                        return nextDirection === 'asc' ? 1 : -1;
                    }
                    return 0;
                });

                $.each($rows, function (_, row) {
                    $tbody.append(row);
                });
            });
    }

    let totalSummaryChart = null;
    let totalSummaryInitialSums = null;


    function getTotalSummary() {
        console.log('getTotalSummary – totals fra backend + dropdownfilter');

        $.ajax({
            type: 'GET',
            url: ajaxPathLicenseTotalSummary,
            data: { dummy: '1' },
            dataType: 'json'
        })
            .done(function (data) {
                $('#dealer_dropdown_wrapper', document).html(data.dropdown_html);
                $('#total_summary_account_list_wrapper', document).html(data.html);

                injectTotalSummarySearch();
                initializeTotalSummarySorting();

                if (data.totals) {
                    totalSummaryInitialSums = [
                        Number(data.totals.active) || 0,
                        Number(data.totals.active_flow_licenses) || 0,
                        Number(data.totals.unused) || 0,
                        Number(data.totals.deactivated) || 0,
                        Number(data.totals.modules) || 0,
                    ];
                    renderTotalSummaryKpis(totalSummaryInitialSums);
                    renderTotalSummaryChart(totalSummaryInitialSums);
                }

                const $dealer = $('#dealer_dropdown', document);

                $dealer
                    .off('change')
                    .on('change', function () {
                        const syncCodesString = $(this)
                            .find('option:selected')
                            .attr('data-sync-codes') || '';

                        const codes = syncCodesString.split(',');

                        const $rows = $('#total_summary_account_table tbody tr', document);
                        const $totalRow = $rows.first();
                        const $dataRows = $rows.not(':first');

                        $dataRows.each(function () {
                            const code = $(this).attr('top_level_sync_code');
                            $(this).toggle(!codes[0] || codes.includes(code));
                        });

                        if (!codes[0] && totalSummaryInitialSums) {
                            const $ths = $totalRow.children('th');
                            $ths.eq(1).find('h2').text(totalSummaryInitialSums[0]);
                            $ths.eq(2).find('h2').text(totalSummaryInitialSums[1]);
                            $ths.eq(3).find('h2').text(totalSummaryInitialSums[2]);
                            $ths.eq(4).find('h2').text(totalSummaryInitialSums[3]);
                            $ths.eq(5).find('h2').text(totalSummaryInitialSums[4]);

                            renderTotalSummaryKpis(totalSummaryInitialSums);
                            renderTotalSummaryChart(totalSummaryInitialSums);
                            hideTailwindPreloader();
                            return;
                        }

                        const sums = [0, 0, 0, 0, 0];
                        $('#total_summary_account_table tbody tr:visible', document)
                            .not(':first')
                            .each(function () {
                                const $td = $(this).children('td');
                                sums[0] += parseInt($td.eq(1).text(), 10) || 0;
                                sums[1] += parseInt($td.eq(2).text(), 10) || 0;
                                sums[2] += parseInt($td.eq(3).text(), 10) || 0;
                                sums[3] += parseInt($td.eq(4).text(), 10) || 0;
                                sums[4] += parseInt($td.eq(5).text(), 10) || 0;
                            });

                        const $ths = $totalRow.children('th');
                        $ths.eq(1).find('h2').text(sums[0]);
                        $ths.eq(2).find('h2').text(sums[1]);
                        $ths.eq(3).find('h2').text(sums[2]);
                        $ths.eq(4).find('h2').text(sums[3]);
                        $ths.eq(5).find('h2').text(sums[4]);

                        renderTotalSummaryKpis(sums);
                        renderTotalSummaryChart(sums);
                        hideTailwindPreloader();
                    })
                    .trigger('change');

                if (window.lucide) {
                    lucide.createIcons();
                }
            })
            .fail(function () {
                $('#total_summary_account_list_wrapper', document).html(
                    '<div class="alert alert-danger">Kunne ikke hente totaloversikt! Er du blitt logget ut?</div>'
                );
                hideTailwindPreloader();
            });

        return false;
    }




    function getControlList(skipIfLoaded = false) {
        if (skipIfLoaded && controlListLoaded) {
            updateWorklistControlChart();
            return false;
        }

        $.ajax({
            type: 'GET',
            url: ajaxPathLicenseControlList,
            data: {
                dummy: '1'
            },
            dataType: 'json'
        }).success(function (data) {
            $('tbody', controlListTable).html(data.html);
            initializeCommentPopovers();
            controlListLoaded = true;
            updateWorklistControlChart();
        }).error(function (data) {
            totalSummaryListWrapper.append('<div class="alert alert-danger">Kunne ikke hente kontrolliste! Er du blitt logget ut?</div>');
        }).always(function () {
            $('#licenses_control_list_wrapper', document).removeClass('hidden');
            hideTailwindPreloader();
        });
        return false;
    }

    function getProcessedLogList() {
        $.ajax({
            type: 'GET',
            url: ajaxPathLicenseProcessedLog,
            data: {
                dummy: '1'
            },
            dataType: 'json'
        }).success(function (data) {
            $('tbody', controlProcessedLogTable).html(data.html);
            initializeCommentPopovers();
        }).error(function (data) {
            totalSummaryListWrapper.append('<div class="alert alert-danger">Kunne ikke hente logg! Er du blitt logget ut?</div>');
        }).always(function() {
            $('#licenses_processed_log_wrapper', document).removeClass('hidden');
            hideTailwindPreloader();
        });
        return false;
    }

    function getLicenseReport(start, end) {
        const data = {};
        if (start && end) {
            data.start_date = start;
            data.end_date = end;
        }

        $.ajax({
            type: 'GET',
            url: ajaxPathLicenseReport,
            data: data,
            dataType: 'json'
        })
            .done(function (res) {
                $('#date_range_wrapper').html(res.date_range_html);
                $('#dealer_report_wrapper').html(res.dropdown_html);
                $('#report_list_wrapper').html(res.html);

                $('#dealer_dropdown')
                    .off('change')
                    .on('change', function () {
                        const codeStr = $(this)
                            .find('option:selected')
                            .data('sync-codes') || '';
                        const codes = codeStr === '' ? [] : codeStr.split(',');

                        $('#license_report_wrapper tbody tr').each(function () {
                            const rowCode = $(this).data('sync-code');
                            const visible = codes.length === 0 || codes.includes(rowCode);
                            $(this).toggle(visible);
                        });

                        let sumActive = 0;
                        let sumDeactivated = 0;
                        let sumDetached = 0;

                        $('#license_report_table tbody tr:visible').each(function () {
                            const $td = $(this).children('td');
                            sumActive += parseInt($td.eq(1).text(), 10) || 0;
                            sumDeactivated += parseInt($td.eq(2).text(), 10) || 0;
                            sumDetached += parseInt($td.eq(3).text(), 10) || 0;
                        });
                        const $ths = $('#license_report_table thead th');
                        $ths.eq(0).find('h2').remove();
                        $ths.eq(1).find('h2').text(sumActive);
                        $ths.eq(2).find('h2').text(sumDeactivated);
                        $ths.eq(3).find('h2').text(sumDetached);
                    })
                    .trigger('change');

                // if (window.license_per_month_chart && typeof window.license_per_month_chart.destroy === 'function') {
                //     window.license_per_month_chart.destroy();
                // }
                // const ctx = document
                //     .getElementById('license_per_month_chart')
                //     .getContext('2d');
                // window.license_per_month_chart = new Chart(ctx, {
                //     type: 'bar',
                //     data: {
                //         labels:   res.monthly_labels,
                //         datasets: [{
                //             label: 'Netto nye lisenser',
                //             data:  res.monthly_new,
                //         }]
                //     },
                //     options: {
                //         responsive: true,
                //         scales: {
                //             x: { title: { display: true, text: 'Måned' } },
                //             y: { beginAtZero: true, title: { display: true, text: 'Antall nye lisenser' } }
                //         },
                //         plugins: { legend: { display: false } }
                //     }
                // });
            })
    }

    // getLicenseReport();

    $(document).on('click', '#load_report_button', function () {
        const start = $('#start_date').val();
        const end = $('#end_date').val();

        if (!start || !end) {
            return alert('Vennligst velg start- og sluttdato');
        }
        if (start > end) {
            return alert('Startdato må være før sluttdato');
        }
        getLicenseReport(start, end);
    });




    function displayAccountLicenseListInTotalSummary(topLevelSyncCode) {
        const wrapperSelector = '#license_worklist_drawer_content';
        const $wrapper = $(wrapperSelector, document);

        openWorklistDrawer();
        clearDrawerRowHighlight();
        $wrapper.html('<div class="p-4 text-center">Laster …</div>');

        $.ajax({
            type: 'GET',
            url: ajaxPathLicense,
            data: {
                sync_code: topLevelSyncCode
            },
            dataType: 'json'
        }).success(function (data) {
            $wrapper.hide();
            $wrapper.html(data.html);
            addTopAccountSummary(topLevelSyncCode, $wrapper);
            initializeCommentPopovers();
        }).error(function () {
            hideTailwindPreloader();
            displayTailwindAlert(
                '',
                'Kunne ikke hente lisenser! Er du blitt logget ut?',
                wrapperSelector,
                'error',
                'replace'
            );
        });
        return false;
    }

    function displayAccountLicenseList(syncCode, topLevelSyncCode, licenseListWrapperSelector) {
        const licenseListWrapper = $(licenseListWrapperSelector, document);

        if (licenseListWrapperSelector === '#license_worklist_drawer_content') {
            openWorklistDrawer();

            // Eventuelt enkel loader inni drawer
            licenseListWrapper.html('<div class="p-4 text-center">Laster …</div>');
        } else {
            showTailwindPreloader();
        }

        $.ajax({
            type: 'GET',
            url: ajaxPathLicense,
            data: {
                sync_code: syncCode,
                top_level_sync_code: topLevelSyncCode
            },
            dataType: 'json'
        }).success(function (data) {
            licenseListWrapper.hide();
            licenseListWrapper.html(data.html);

            addTopAccountSummary(topLevelSyncCode, licenseListWrapper);
            initializeCommentPopovers();
        }).error(function () {
            hideTailwindPreloader();
            displayTailwindAlert(
                '',
                'Kunne ikke hente oppsummering! Er du blitt logget ut?',
                licenseListWrapperSelector,
                'error',
                'replace'
            );
        }).always(function () {
            if (licenseListWrapperSelector !== '#license_worklist_drawer_content') {
                $('html, body').animate({ scrollTop: 0 }, 500);
            }
        });

        return false;
    }



    function addTopAccountSummary(topLevelSyncCode, wrapper) {
        $.ajax({
            type: 'GET',
            url: ajaxPathLicenseTopAccountSummary,
            data: {
                sync_code: topLevelSyncCode
            },
            dataType: 'json'
        }).success(function (data) {
            wrapper.prepend(data.html);
        }).error(function () {
            displayTailwindAlert(
                '',
                'Kunne ikke hente oppsummering! Er du blitt logget ut?',
                `#${wrapper.attr('id')}`,
                'error',
                'replace'
            );
        }).always(function () {
            wrapper.fadeIn('fast');
            hideTailwindPreloader();
        });

        return false;
    }


    function markLicenseAsProcessed(tr, licenseKey, priceExVat) {
        showTailwindPreloader();

        $.ajax({
            type: 'PUT',
            url: ajaxPathLicense + '/' + licenseKey,
            data: {
                processed_by_invoicing_department: '1',
                price_ex_vat: priceExVat
            },
            dataType: 'json'
        }).success(function () {
            tr.remove();
            updateWorklistControlChart();
        }).error(function (data) {
            alert('Kunne ikke markere som behandlet, er du blitt logget ut?');
        }).always(function () {
            hideTailwindPreloader();
        });
        return false;
    }

    function markModuleAsProcessed(tr, companyModuleId, priceExVat, syncCode) {
        showTailwindPreloader();

        $.ajax({
            type: 'POST',
            url: ajaxPathCompanyModule,
            data: {
                processed_by_invoicing_department: '1',
                company_module_id: companyModuleId,
                sync_code: syncCode,
                price_ex_vat_for_customer: priceExVat,
                keep_existing_module_status: 1
            }
        }).success(function (data) {
            tr.remove();
            updateWorklistControlChart();
        }).error(function (data) {
            alert('Kunne ikke markere som behandlet, er du blitt logget ut?');
        }).always(function () {
            hideTailwindPreloader();
        });
        return false;
    }

    function markLicenseAsControl(tr, licenseKey) {
        showTailwindPreloader();

        $.ajax({
            type: 'PUT',
            url: ajaxPathLicense + '/' + licenseKey,
            data: {
                processed_by_invoicing_department: '2'
            },
            dataType: 'json'
        }).success(function () {
            tr.remove();
            updateWorklistControlChart();
        }).error(function (data) {
            alert('Kunne ikke markere som kontroll, er du blitt logget ut?');
        }).always(function () {
            hideTailwindPreloader();
        });
        return false;
    }

    function markModuleAsControl(tr, companyModuleId, syncCode) {
        showTailwindPreloader();

        $.ajax({
            type: 'POST',
            url: ajaxPathCompanyModule,
            data: {
                processed_by_invoicing_department: '2',
                company_module_id: companyModuleId,
                sync_code: syncCode
            }
        }).success(function (data) {
            tr.remove();
            updateWorklistControlChart();
        }).error(function (data) {
            alert('Kunne ikke markere som kontroll, er du blitt logget ut?');
        }).always(function () {
            hideTailwindPreloader();
        });
        return false;
    }

    function markLicenseAsUnproccesed(tr, licenseKey) {
        showTailwindPreloader();

        $.ajax({
            type: 'PUT',
            url: ajaxPathLicense + '/' + licenseKey,
            data: {
                processed_by_invoicing_department: '0'
            },
            dataType: 'json'
        }).success(function () {
            tr.remove();
            updateWorklistControlChart();
        }).error(function (data) {
            alert('Kunne ikke legge i arbeidsliste, er du blitt logget ut?');
        }).always(function () {
            hideTailwindPreloader();
        });
        return false;
    }

    function markModuleAsUnproccesed(tr, companyModuleId, syncCode) {
        showTailwindPreloader();

        $.ajax({
            type: 'POST',
            url: ajaxPathCompanyModule,
            data: {
                processed_by_invoicing_department: '0',
                company_module_id: companyModuleId,
                sync_code: syncCode
            }
        }).success(function (data) {
            tr.remove();
            updateWorklistControlChart();
        }).error(function (data) {
            alert('Kunne ikke legge i arbeidsliste, er du blitt logget ut?');
        }).always(function () {
            hideTailwindPreloader();
        });
        return false;
    }

    function reloadWorkList() {
        location.reload();
    }

    function activateLicenseDatePickers() {
        if ($('form[name="license_form"] input#activation_date').length) {
            new Litepicker({
                element: $('form[name="license_form"] input#activation_date')[0],
                singleMode: true,
                numberOfMonths: 1,
                numberOfColumns: 1,
                format: 'DD.MM.YYYY',
                autoApply: true,
                dropdowns: {
                    minYear: 2017,
                    maxYear: new Date().getFullYear(),
                    months: true,
                    years: true,
                },
            });
        }

        if ($('form[name="license_form"] input#expiration_date').length) {
            new Litepicker({
                element: $('form[name="license_form"] input#expiration_date')[0],
                singleMode: true,
                numberOfMonths: 1,
                numberOfColumns: 1,
                format: 'DD.MM.YYYY',
                autoApply: true,
                dropdowns: {
                    minYear: 2017,
                    maxYear: new Date().getFullYear() + 1,
                    months: true,
                    years: true,
                },
            });
        }
    }

    function removeAccountSummaryAndLicenses() {
        $('.table_account_summary_wrapper', document).remove();
        $('.customer_licenses', document).remove();
    }



    if ($('#licenses_page_wrapper').length) {
        updateWorklistControlChart();
        // Hent kontrolliste én gang i bakgrunnen slik at diagrammet alltid har begge kildene
        getControlList(true);
    }

    if ($('#licenses-reports').length) {
        // Initialize dealer filter selector
        var $dealerFilter = $('#report-dealer-filter');

        // Datepicker options
        var dpOptions = {
            closeText: 'Lukk',
            prevText: '&laquo;Forrige',
            nextText: 'Neste&raquo;',
            currentText: 'I dag',
            dateFormat: 'dd.mm.yy',
            firstDay: 1,
            changeMonth: true,
            changeYear: true,
            monthNames: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
            dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
            dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
            onClose: function (selectedDate) {
                if (this.id === 'report-from') {
                    $('#report-to').datepicker('option', 'minDate', selectedDate);
                }
            }
        };
        $('#report-from').datepicker(dpOptions);
        $('#report-to').datepicker(dpOptions);

        // Handle Generate Report button click
        $('#run-report').click(function () {
            var dealerId = $dealerFilter.val();
            var fromDate = $('#report-from').val();
            var toDate = $('#report-to').val();

            if (!fromDate || !toDate) {
                alert('Velg både fra- og til-dato før du genererer rapporten.');
                return;
            }

            var $out = $('#report-output');
            $out.html('<div class="text-center"><img src="/includes/charts/gfx/ajax-loader.gif" alt="Loading..."/></div>');

            $.ajax({
                type: 'GET',
                url: '/action/licenses/reports',
                data: {
                    from: fromDate,
                    to: toDate
                },
                dataType: 'json'
            }).done(function (data) {
                renderActivityReport(data, $out);
            }).fail(function () {
                $out.html('<div class="alert alert-danger">Kunne ikke hente rapport. Prøv igjen senere.</div>');
            });
        });

        function renderActivityReport(data, $container) {
            var html = '<div class="report-summary">';
            html += '<p><strong>Nye lisenser:</strong> ' + data.totals.created + '</p>';
            html += '<p><strong>Deaktiverte lisenser:</strong> ' + data.totals.deactivated + '</p>';
            html += '<p><strong>Frigjorte lisenser:</strong> ' + data.totals.detached + '</p>';
            html += '<p><strong>Netto nye lisenser:</strong> ' + data.totals.net_new + '</p>';
            html += '</div>';
            html += '<canvas id="report-chart" style="width:100%;height:300px;"></canvas>';
            $container.html(html);

            var labels = data.labels;
            var netData = data.series.map(function (item) {
                return item.net_new;
            });

            var ctx = document.getElementById('report-chart').getContext('2d');
            new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Netto nye lisenser',
                        data: netData,
                        fill: false
                    }]
                },
                options: {
                    scales: {
                        xAxes: [{display: true, scaleLabel: {display: true, labelString: 'Måned'}}],
                        yAxes: [{display: true, scaleLabel: {display: true, labelString: 'Antall'}}]
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
            });
        }
    }
});
